import axios from 'axios'

// Maintenance mode middleware
export const maintenanceModeMiddleware = async (to, from, next) => {
  let maintenanceData = null;
  
  try {
    // Check maintenance mode status from API
    const response = await axios.get('/api/maintenance-status')
    maintenanceData = response.data
    
    // If not in maintenance mode
    if (!maintenanceData.isMaintenanceEnabled) {
      // If user is on maintenance page but maintenance is disabled, redirect to root
      if (to.name === 'maintenance') {
        return next({ path: '/' });
      }
      // Otherwise allow normal navigation
      return next();
    }
  } catch (error) {
    // If API fails, assume maintenance mode is disabled
    console.error('Failed to check maintenance status:', error)
    
    // If user is on maintenance page but we can't verify maintenance status, redirect to root
    if (to.name === 'maintenance') {
      return next({ path: '/' });
    }
    return next();
  }
  
  // If maintenance is enabled and already on maintenance page, allow access
  if (to.name === 'maintenance') {
    return next();
  }
  
  // Check if user has the bypass parameter
  const bypassToken = maintenanceData.bypassToken || 'SbbKvO8EYe';
  const maintenanceKey = to.query.maintenanceKey;
  
  // If user has the correct bypass token, set a flag in sessionStorage and allow access
  if (maintenanceKey === bypassToken) {
    sessionStorage.setItem('maintenanceBypass', 'true');
    return next();
  }
  
  // Check if user has already bypassed maintenance mode in this session
  const hasBypassed = sessionStorage.getItem('maintenanceBypass') === 'true';
  
  if (hasBypassed) {
    return next();
  }
  
  // Redirect to maintenance page
  return next({ name: 'maintenance' });
};